import Cookies from 'js-cookie';
const SITE_NAME = window.siteConfig().siteName;
const NAME = `${SITE_NAME}_search-history`;

const SearchHistoryCookie = {
    add: keyword => {
        const oldCookie = JSON.parse(Cookies.get(NAME) || '[]');
        // newCookieValues[slug] = variant;
        const index = oldCookie.indexOf(keyword);
        if (index > -1) {
            //remove old keyword if
            oldCookie.splice(index, 1);
        }

        // always unshift new keyword
        oldCookie.unshift(keyword);
        Cookies.set(NAME, JSON.stringify(oldCookie.slice(0, 6)), {
            expires: 365,
            path: window.siteConfig()?.contextPath || '/',
        });
    },
    get: () => {
        return JSON.parse(Cookies.get(NAME) || '[]');
    },
};

export default SearchHistoryCookie;
